
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired891"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired891"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bC5Q6", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("bDs0i"),
    $parcel$import("3ZdEf")
]).then(()=>parcelRequire('ivJiH'));

});

parcelRegister("7RQhS", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("bDs0i"),
    $parcel$import("cb4iL")
]).then(()=>parcelRequire('kBSio'));

});

var $3ef7899dab2709ab$exports = {};
$parcel$extendImportMap({
    "3ZdEf": "install-dialog.60d890c4.js",
    "UccxX": "stub_flasher_32.f363bb60.js",
    "kNN8R": "stub_flasher_32c2.ebc044db.js",
    "5Ks8K": "stub_flasher_32c3.31c91066.js",
    "245Va": "stub_flasher_32c5.89a6ca47.js",
    "bvYmY": "stub_flasher_32c6.0fc227b0.js",
    "5h7T3": "stub_flasher_32c61.22ccd7b8.js",
    "8kbWn": "stub_flasher_32h2.d6ed5202.js",
    "iFQyn": "stub_flasher_32p4rc1.b03978dc.js",
    "8NpD0": "stub_flasher_32p4.911b8bbe.js",
    "jt5Qh": "stub_flasher_32s2.274137ca.js",
    "gUl0K": "stub_flasher_32s3.406897db.js",
    "74dD7": "stub_flasher_8266.fdea156c.js",
    "4rZqf": "esp32.652ddba6.js",
    "chalg": "esp32c2.3ad743ca.js",
    "hJ60H": "esp32c3.87c2e269.js",
    "41obi": "esp32c6.2815eff1.js",
    "5Ge7e": "esp32c61.2c23b071.js",
    "hUedn": "esp32c5.1220dc3c.js",
    "ecst0": "esp32h2.648e32c2.js",
    "iJtgi": "esp32s3.5df18c2c.js",
    "gVe3x": "esp32s2.9a8c7580.js",
    "71B5g": "esp32p4.8b805ed8.js",
    "bDs0i": "install-dialog.36141e48.js",
    "cb4iL": "no-port-picked.731e0645.js"
});



const $e308cd93adbb12d3$export$64605811ab45167f = async (button)=>{
    (parcelRequire("bC5Q6"));
    let port;
    try {
        port = await navigator.serial.requestPort();
    } catch (err) {
        if (err.name === "NotFoundError") {
            (parcelRequire("7RQhS")).then((mod)=>mod.openNoPortPickedDialog(()=>$e308cd93adbb12d3$export$64605811ab45167f(button)));
            return;
        }
        alert(`Error: ${err.message}`);
        return;
    }
    if (!port) return;
    try {
        await port.open({
            baudRate: 115200,
            bufferSize: 8192
        });
    } catch (err) {
        alert(err.message);
        return;
    }
    const el = document.createElement("ewt-install-dialog");
    el.port = port;
    el.manifestPath = button.manifest || button.getAttribute("manifest");
    el.overrides = button.overrides;
    el.addEventListener("closed", ()=>{
        port.close();
    }, {
        once: true
    });
    document.body.appendChild(el);
};


class $b21fb1f87573f3f6$export$9f8965e842050973 extends HTMLElement {
    connectedCallback() {
        if (this.renderRoot) return;
        this.renderRoot = this.attachShadow({
            mode: "open"
        });
        if (!$b21fb1f87573f3f6$export$9f8965e842050973.isSupported || !$b21fb1f87573f3f6$export$9f8965e842050973.isAllowed) {
            this.toggleAttribute("install-unsupported", true);
            this.renderRoot.innerHTML = !$b21fb1f87573f3f6$export$9f8965e842050973.isAllowed ? "<slot name='not-allowed'>You can only install ESP devices on HTTPS websites or on the localhost.</slot>" : "<slot name='unsupported'>Your browser does not support installing things on ESP devices. Use Mozilla Firefox, Google Chrome or Microsoft Edge.</slot>";
            return;
        }
        this.toggleAttribute("install-supported", true);
        const slot = document.createElement("slot");
        slot.addEventListener("click", async (ev)=>{
            ev.preventDefault();
            (0, $e308cd93adbb12d3$export$64605811ab45167f)(this);
        });
        slot.name = "activate";
        const button = document.createElement("button");
        button.innerText = "Connect";
        slot.append(button);
        if ("adoptedStyleSheets" in Document.prototype && "replaceSync" in CSSStyleSheet.prototype) {
            const sheet = new CSSStyleSheet();
            sheet.replaceSync($b21fb1f87573f3f6$export$9f8965e842050973.style);
            this.renderRoot.adoptedStyleSheets = [
                sheet
            ];
        } else {
            const styleSheet = document.createElement("style");
            styleSheet.innerText = $b21fb1f87573f3f6$export$9f8965e842050973.style;
            this.renderRoot.append(styleSheet);
        }
        this.renderRoot.append(slot);
    }
}
$b21fb1f87573f3f6$export$9f8965e842050973.isSupported = "serial" in navigator;
$b21fb1f87573f3f6$export$9f8965e842050973.isAllowed = window.isSecureContext;
$b21fb1f87573f3f6$export$9f8965e842050973.style = `
  button {
    position: relative;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    padding: 10px 24px;
    color: var(--esp-tools-button-text-color, #fff);
    background-color: var(--esp-tools-button-color, #03a9f4);
    border: none;
    border-radius: var(--esp-tools-button-border-radius, 9999px);
  }
  button::before {
    content: " ";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0.2;
    border-radius: var(--esp-tools-button-border-radius, 9999px);
  }
  button:hover::before {
    background-color: rgba(255,255,255,.8);
  }
  button:focus {
    outline: none;
  }
  button:focus::before {
    background-color: white;
  }
  button:active::before {
    background-color: grey;
  }
  :host([active]) button {
    color: rgba(0, 0, 0, 0.38);
    background-color: rgba(0, 0, 0, 0.12);
    box-shadow: none;
    cursor: unset;
    pointer-events: none;
  }
  .hidden {
    display: none;
  }`;
customElements.define("esp-web-install-button", $b21fb1f87573f3f6$export$9f8965e842050973);


var $d912fbb198177665$exports = {};
$d912fbb198177665$exports = JSON.parse("{\"name\":\"SFP-Tool\",\"version\":\"1.2.3.4\",\"new_install_prompt_erase\":false,\"builds\":[{\"chipFamily\":\"ESP32-S3\",\"parts\":[{\"path\":\"https://s3.jonasled.de/sfp-tool/firmware.bin\",\"offset\":0}]}]}");




//# sourceMappingURL=Firmwareupdater.a26f6b84.js.map
